// Lookup table powering the signup tier picker on /auth and the
// Pricing → /auth pre-select. The price IDs are the lookup keys we
// keep stable across sandbox and live.
import { TIER_PRICING } from "@/lib/tier";

export type PaidTier = "starter" | "plus" | "pro" | "elite" | "agency";
export type Billing = "monthly" | "yearly";

export interface PlanOption {
  tier: PaidTier;
  billing: Billing;
  priceId: string;
  label: string;
  amount: number;
}

const LABELS: Record<PaidTier, string> = {
  starter: "Starter",
  plus: "Plus",
  pro: "Pro",
  elite: "Elite",
  agency: "Agency",
};

export const PAID_TIERS: PaidTier[] = ["starter", "plus", "pro", "elite", "agency"];

export function planFor(tier: PaidTier, billing: Billing): PlanOption {
  return {
    tier,
    billing,
    priceId: `${tier}_${billing}`,
    label: LABELS[tier],
    amount: TIER_PRICING[tier][billing],
  };
}

export function parsePlanParam(value: string | null): { tier: PaidTier; billing: Billing } | null {
  if (!value) return null;
  const m = /^(starter|plus|pro|elite|agency)_(monthly|yearly)$/.exec(value);
  if (!m) return null;
  return { tier: m[1] as PaidTier, billing: m[2] as Billing };
}
